import { render, staticRenderFns } from "./newProfile.vue?vue&type=template&id=6e67e0ca&scoped=true"
import script from "./newProfile.vue?vue&type=script&lang=js"
export * from "./newProfile.vue?vue&type=script&lang=js"
import style0 from "./newProfile.vue?vue&type=style&index=0&id=6e67e0ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e67e0ca",
  null
  
)

export default component.exports